/**
 * Returns a function that calls another function (onPause) if there is a pause in call for the specified period (ms).
 *
 * @param onPause Callback function
 * @param ms Time to pause for
 * @returns {function()} Pause resetting function
 */
const createPauser = (onPause, ms) => {
	let handle = null;

	return value => {
		// Every time an event happens, we need to reset the timer. Nothing happens until the original MS has elapsed.
		if (handle) window.clearTimeout(handle);
		handle = window.setTimeout(() => {
			handle = null;
			onPause(value);
		}, ms);
	};
};

export default createPauser;



// WEBPACK FOOTER //
// ./src/pauser.js